
export function countFragments(image: File) {
  const headers = new Headers({});
  const token = localStorage.getItem("token");
  if (token) {
    headers.set("Authorization", `Token ${token}`);
  }

  const formData = new FormData();
  formData.append("file", image);
  formData.append("name", image.name);

  return fetch(`${import.meta.env.VITE_API_HOST}/api/v1/fragments-count/`, {
    method: "POST",
    body: formData,
    headers
  })
    .then(r => {
      if (!r.ok) throw new Error("Unable to upload file.");
      return r.json();
    });
}
